import { render, staticRenderFns } from "./com-table.vue?vue&type=template&id=ef64cadc"
import script from "./com-table.vue?vue&type=script&lang=js"
export * from "./com-table.vue?vue&type=script&lang=js"
import style0 from "./com-table.vue?vue&type=style&index=0&id=ef64cadc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports